import { Text } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";
import { getMarketplaceIcon } from "../../lib/marketplaceFormat";
import { toInformationRequest } from "../../lib/marketplaceRequests";
import type {
  MarketplaceCapability,
  SelectedMarketplaceRequest,
} from "../../types/marketplace";
import { MarketplaceCard } from "./MarketplaceCard";

type AvailableCapabilityCardProps = {
  capability: MarketplaceCapability;
  onSelect: (request: SelectedMarketplaceRequest) => void;
};

export function AvailableCapabilityCard({
  capability,
  onSelect,
}: AvailableCapabilityCardProps) {
  const { t } = useTranslation();

  return (
    <MarketplaceCard
      title={capability.name}
      type={capability.type}
      description={capability.description}
      icon={getMarketplaceIcon(capability.type, capability.name)}
      onClick={() => onSelect(toInformationRequest(capability))}
    >
      {capability.whyRecommended ? (
        <Text size="sm" tone="subtle">
          {t("marketplace.recommendedReason", {
            reason: capability.whyRecommended,
          })}
        </Text>
      ) : null}
    </MarketplaceCard>
  );
}
